import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import BrandService from '@iso/services/SettingsService/ProductService/BrandService';

function* deleteBrand({ id }) {
    try {
        yield call(BrandService.deleteOne, id);
        yield put(actions.deleteBrandSucceeded(id));
    } catch (error) {
        yield put(actions.deleteBrandFailed(extractError(error)));
    }
}

function* watchDeleteBrand() {
    yield takeEvery(
        types.REQUEST_DELETE_BRAND,
        deleteBrand,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteBrand),
    ]);
}

export default deleteSaga;
